import { render, staticRenderFns } from "./MembersGroupsAssociations.vue?vue&type=template&id=f16187d0"
import script from "./MembersGroupsAssociations.vue?vue&type=script&lang=js"
export * from "./MembersGroupsAssociations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports